<template>
  <div id="msg-bar" :class="(message_notification.templateCode ? message_notification.templateCode.toLowerCase() : 'message-bar')" v-if="message !== null" v-html="message">
  </div>
</template>

<script>

/* eslint-disable */
import TimPartyMixin from '../mixins/TimPartyMixin';

export default {
  name: "MessageBar",
  mixins: [TimPartyMixin],
  props: {
    apiUrl: {
      type: String,
      required: false,
      default: '/api/catalog/handleAction'
    }
  },
  data: function () {
    return {
      message: null,
      message_notification: null,
    }
  },
  mounted: function () {
    this.observeHeight();

  },
  methods: {
    getMessageFromUser: function () {
      var self = this;
      var payload = {
        action: 'getMessageFromUser',
      };

      this.setApiUrl(this.user.endpoints.user);
      this.callApi(payload, function (response) {
        if (typeof response.infoContent !== "undefined") {
          self.message = response.infoContent.description;
        }
        self.message_notification = response;
      });
    }
  },
  watch: {
    message: function () {
      this.observeHeight();
    },
    notifications: function () {
      this.getMessageFromUser();
    }
  },
}
</script>
